/**
 * Checks if a section has content
 * HINT: section converted to HTML stores content in the `content` field, old TEXT sections still have their content in the `paragraphs` field
 * @param {object} section - section object
 * @returns {boolean} - true if the section has content
 */
export const longFormSectionHasContent = (section) => {
  return section?.content?.length > 0 || section?.paragraphs?.length > 0;
};
